import React from "react"
import Logo from "../images/blackbox-logo.svg"

export default function BlackboxLogo() {
    return (
        <a href="https://blackboxfinancetech.com/" className="flex justify-start items-center">
            <span className="sr-only">Blackbox Logo</span>
            <img
                alt="Blackbox Logo"
                className="h-12 w-auto sm:h-16"
                src={Logo}
            />
            <span className="pl-1 font-semibold text-white text-lg">BLACKBOX</span>
        </a>
    )
}